var components
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 = _vm.__map(_vm.options, function(item, index) {
    var $orig = _vm.__get_orig(item)

    var s0 = _vm.showBtn ? _vm.__get_style([_vm.btnStyle(item.style)]) : null
    return {
      $orig: $orig,
      s0: s0
    }
  })

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0
      }
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }